import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';
import { rtkAppRetry } from '#store/apiRetry.ts';

export const TAGS = {
    POIS: 'POIS',
};

export const apiPoisRoot = createApi({
    tagTypes: Object.keys(TAGS),
    reducerPath: 'apiPois',
    baseQuery: rtkAppRetry(
        fetchBaseQuery({
            baseUrl: import.meta.env.VITE_POIS_API,
            prepareHeaders,
        })
    ),
    endpoints: () => ({}),
});
